import React from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import NoData from "components/common/NoData";
import NotificationCard from "./NotificationCard";

function NotificationDrawer({
  open,
  notifications,
  onClose,
  onNotificationClick,
}) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      className="bs-drawer typ-notification"
    >
      <div className="drawer-content">
        <div className="drawer-header">
          <div className="mod-title">
            <h3 className="title">Notifications</h3>
            <IconButton
              className="bs-btn btn-icon"
              onClick={onClose}
              aria-label="Close"
              size="small"
            >
              <span className="icon icon-close"></span>
            </IconButton>
          </div>
        </div>
        <div className="drawer-body">
          {notifications.length === 0 ? (
            <NoData message="No notifications yet" />
          ) : (
            <ul className="noti-list">
              {notifications.map((notification) => (
                <li key={notification.id}>
                  <NotificationCard
                    variant="drawer"
                    notification={notification}
                    isUnread={!notification.isRead}
                    onClick={onNotificationClick}
                  />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Drawer>
  );
}

export default NotificationDrawer;
